import { useState, useCallback } from 'react';
import isEmpty from 'lodash/fp/isEmpty';
import moment from 'moment';
import analytics from 'service/analytics';
import styles from './coupon-list.module.sass';
import classNames from 'classnames/bind';
import { CouponFillIcon, ChevronDownIcon } from 'icons';
import Hr from 'componets/hr';

const cx = classNames.bind(styles);

function formatTime(iso) {
  return moment(iso).format('YYYY.MM.DD HH:mm');
}

export const CouponItem = ({ type, coupon, className }) => {
  const { name, effectiveAt, expiresAt, availableTimes, descriptions } = coupon;

  const [isOpen, setIsOpen] = useState(false);

  const hasDescriptions = !isEmpty(descriptions);

  const handleToggle = useCallback(() => {
    if (isEmpty(descriptions)) return;
    setIsOpen(prev => {
      const newState = !prev;
      analytics.couponPagePromotionDetailClick({ isOpen: newState });
      return newState;
    });
  }, [descriptions]);

  let previewIconSection = null;

  switch (type) {
    case 'valid':
      previewIconSection = (
        <div className={cx(styles['valid-coupon-item-preview-icon'], styles['coupon-item-preview-icon'])}>
          <CouponFillIcon />
          {availableTimes > 0 && <span>{`${availableTimes} 次`}</span>}
        </div>
      );
      break;
    case 'invalid':
      previewIconSection = (
        <div className={cx(styles['invalid-coupon-item-preview-icon'], styles['coupon-item-preview-icon'])}>
          <CouponFillIcon />
        </div>
      );
      break;
    default:
      break;
  }

  const couponItemPreviewClassName = cx('coupon-item-preview', {
    clickable: hasDescriptions,
  });

  return (
    <li className={cx('coupon-item', className)}>
      <div className={couponItemPreviewClassName} onClick={handleToggle}>
        {previewIconSection}
        <div className={styles['coupon-item-preview-info']}>
          <div className={styles['coupon-item-preview-name']}>{name}</div>
          <div className={styles['coupon-item-preview-effective-at']}>{`${formatTime(effectiveAt)} 啟用`}</div>
          <div className={styles['coupon-item-preview-expires-at']}>{`${formatTime(expiresAt)} 到期`}</div>
        </div>
        {hasDescriptions && (
          <ChevronDownIcon
            color="#999999"
            style={{
              transform: `rotate(${isOpen ? '180deg' : '0deg'})`,
              transition: 'transform 0.2s',
            }}
          />
        )}
      </div>
      {isOpen && (
        <>
          <Hr />
          <ul className={styles['coupon-item-description-list']}>
            {descriptions.map(d => (
              <li
                key={d}
                dangerouslySetInnerHTML={{
                  __html: d,
                }}
              />
            ))}
          </ul>
        </>
      )}
    </li>
  );
};
